import { render, staticRenderFns } from "./InsuranceContactSelection.vue?vue&type=template&id=51ca8f2e"
import script from "./InsuranceContactSelection.vue?vue&type=script&lang=js"
export * from "./InsuranceContactSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports